import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Plus } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export default function HigherAssignForm({ joinerId, onAdded }) {
  const [drops, setDrops] = useState([]);
  const [dropId, setDropId] = useState("");
  const [setName, setSetName] = useState("");
  const [pcs, setPcs] = useState("1");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/higher/drops").then((r) => setDrops(r.data)).catch(() => setDrops([]));
  }, []);
  const drop = drops.find((d) => d.id === dropId);

  const add = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post(`/higher/drops/${dropId}/claims`, { joiner_id: joinerId, set_name: setName, pcs: Number(pcs) });
      toast.success(`${pcs} PC(s) of ${setName} added`);
      setPcs("1");
      onAdded();
      api.get("/higher/drops").then((r) => setDrops(r.data)).catch(() => {});
    } catch (err) {
      toast.error(errMsg(err, "Couldn't add PCs"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={add} data-testid="higher-assign-form" className="mt-8 rounded-2xl border border-sky-400/20 bg-sky-500/5 p-4">
      <div className="text-sm font-semibold">Assign PCs <span className="text-xs font-normal text-zinc-500">(admin)</span></div>
      {drops.length === 0 ? (
        <div className="mt-2 text-xs text-zinc-500">Add a Higher Drop first from Admin → Yani - Higher.</div>
      ) : (
        <div className="mt-3 grid grid-cols-1 sm:grid-cols-[1fr_1fr_6rem_auto] gap-2">
          <Select value={dropId} onValueChange={(v) => { setDropId(v); setSetName(""); }}>
            <SelectTrigger data-testid="higher-assign-drop-select" className="bg-zinc-900"><SelectValue placeholder="Higher Drop" /></SelectTrigger>
            <SelectContent>{drops.map((d) => <SelectItem key={d.id} value={d.id} data-testid={`higher-assign-drop-option-${d.id}`}>{d.name}</SelectItem>)}</SelectContent>
          </Select>
          <Select value={setName} onValueChange={setSetName} disabled={!drop}>
            <SelectTrigger data-testid="higher-assign-set-select" className="bg-zinc-900"><SelectValue placeholder="Set name" /></SelectTrigger>
            <SelectContent>{(drop?.fill || []).map((f, i) => {
              const left = f.available - f.assigned;
              return <SelectItem key={f.name} value={f.name} disabled={left <= 0} data-testid={`higher-assign-set-option-${i}`}>{f.name} · {left > 0 ? `${left} of ${f.available} left` : "Full"}</SelectItem>;
            })}</SelectContent>
          </Select>
          <Input data-testid="higher-assign-pcs-input" type="number" min={1} max={999} required value={pcs} onChange={(e) => setPcs(e.target.value)} className="bg-zinc-900" aria-label="Number of PCs" />
          <Button type="submit" disabled={busy || !dropId || !setName} data-testid="higher-assign-submit" className="rounded-xl bg-white text-zinc-950 hover:bg-zinc-200 font-semibold">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Plus className="h-4 w-4 mr-1" />} Add PCs
          </Button>
        </div>
      )}
    </form>
  );
}
